import React from 'react';
import { Wind } from 'lucide-react';
interface LogoProps {
  onClick?: () => void;
  className?: string;
}
export function Logo({
  onClick,
  className = ''
}: LogoProps) {
  return <button onClick={onClick} className={`flex items-center space-x-2 group cursor-pointer ${className}`} aria-label="Strona główna AuraSync" data-id="element-658">
      <Wind className="w-5 h-5 text-zen-accent group-hover:scale-110 transition-transform" strokeWidth={1.5} data-id="element-659" />
      <span className="text-lg font-light tracking-widest text-zen-text" data-id="element-660">
        AuraSync
      </span>
    </button>;
}